// extracted by mini-css-extract-plugin
module.exports = {"root":"TeamsBlock_root__gSOB1","title":"TeamsBlock_title__YAA7p"};